import { createContext } from 'react';

export const PayrollDetailContext = createContext();
